import React from 'react';

const PaymentCancelPage = ({ onSignOut, onRetryPayment }) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-red-50 font-sans">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md text-center">
        <h2 className="text-2xl font-bold mb-4 text-red-700">Payment Cancelled</h2>
        <p className="text-gray-700 mb-6">
          Your payment was cancelled or failed.<br />
          Please try again or contact support if you continue to have issues.
        </p>
        <div className="space-y-3">
          <button
            onClick={onRetryPayment}
            className="w-full py-2 px-4 bg-blue-600 text-white font-semibold rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75 transition duration-200 ease-in-out"
          >
            Try Again
          </button>
          <button
            onClick={onSignOut}
            className="w-full py-2 px-4 bg-red-600 text-white font-semibold rounded-md shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-75 transition duration-200 ease-in-out"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage; 